<template>
  <div class="footer-wrapper">
    <div class="landing-footer footer-brand hero-max-width">
      <div class="footer-title">
        <div class="hero-logo">
          <img
            :class="isDesktop ? 'logo' : 'logo-mobile'"
            v-lazy-load data-src="~/assets/img/moniker.png"
          />
        </div>
      </div>
      <div class="footer-contact-us">
        <div class="a-little-bold">
          Contact us
        </div>
        <div style="color: rgba(0, 0, 0, 0.6);">
          workera@workera.ai <br />
          +1 (650) 567-3636
        </div>
      </div>
      <div class="footer-follow-us">
        <div class="a-little-bold">
          Follow Us
        </div>
        <div>
          <div>
            <a
              target="_blank"
              rel="noopener"
              href="https://www.facebook.com/pg/Workera-104287324400610/about/?ref=page_internal"
              class="social-media"
            >
              <img v-lazy-load data-src="~/assets/img/landing-page/facebook.png" />
            </a>
          </div>
          <div>
            <a
              target="_blank"
              rel="noopener"
              href="https://twitter.com/workera_"
              class="social-media"
            >
              <img v-lazy-load data-src="~/assets/img/landing-page/twitter.png" />
            </a>
          </div>
          <div>
            <a
              target="_blank"
              rel="noopener"
              href="https://www.linkedin.com/company/workera-ai"
              class="social-media"
            >
              <img v-lazy-load data-src="~/assets/img/landing-page/linkedin.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="footer-further-information">
        <div class="a-little-bold">
          Further Information
        </div>
        <div>
          <a target="_blank" href="https://workera.ai/privacy-policy" class="social-media">
            Privacy Policies
          </a>
        </div>
        <div>
          <a
            target="_blank"
            href="https://workera.ai/terms-of-use"
            class="social-media"
          >
            Terms of Use
          </a>
        </div>
        <div>
          <a
            target="_blank"
            href="https://workera.ai/security"
            class="social-media"
          >
            Security
          </a>
        </div>
        <div>
          <a target="_blank" href="https://workera.ai/careers" class="social-media">
            Careers
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deviceMixin from "~/mixins/deviceMixin";
export default {
  mixins: [deviceMixin]
};
</script>

<style lang="scss" scoped>
.landing-footer {
  display: flex;
  padding-top: 5rem;
  padding-bottom: 9rem;
  align-items: baseline;
  color: #322f4d;
  flex-wrap: wrap;
}
.landing-footer a {
  color: rgba(0, 0, 0, 0.6);
  border-color: rgba(0, 0, 0, 0.6);
}
.landing-footer > div {
  font-size: 1.1rem;
  font-weight: 500;
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  color: #322f4d;
  padding-left: 4rem;
  margin-top: 2rem;
}
.a-little-bold {
  font-weight: 600;
}
.footer-wrapper {
  background: $light-grey;
  /*#002956*/
}
.footer-title > div:first-child {
  font-weight: 600;
  font-size: 1.7rem;
}
.footer-title > div:last-child {
  font-size: 1rem;
}
.footer-follow-us > div:last-child {
  display: flex;
  margin-top: 1rem;
}
.footer-follow-us img {
  width: 30px;
  height: 30px;
  margin: 0.2rem;
}
</style>
